module.exports = "/static-assets/_next/static/images/copycats-7d64a2e40b946c57744f993e6fb41228.png";